/**
 * `?demo=1` is the glassly.ai embed: the store renders as the phone app's
 * Store screen and advances its featured cards. Read once at load so it
 * survives client-side navigation, which drops the query string.
 */
export const embedded = new URLSearchParams(window.location.search).get("demo") === "1";
